import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {loadFolderAndDecks} from '../lib/tycho';
import Deck from '../containers/Deck.js';
import useSlideRotator from '../hooks/useSlideRotator.js';
import './Screen.css';

const Screen = ({
  folderId,
  location,
  currentDeckId,
  uiMode
}) => {
  useEffect(() => {
    loadFolderAndDecks(folderId);
  }, [folderId]);

  useSlideRotator();

  return (
    <div className={classNames('Screen', {
      [`Screen--${uiMode}`]: true
    })}>
      <Deck id={currentDeckId} loadSubData={true} location={location} />
    </div>
  );
};

Screen.propTypes = {
  folderId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  currentDeckId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  location: PropTypes.object.isRequired,
  uiMode: PropTypes.string.isRequired
};

export default Screen;
